class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close(),
    );
    this.querySelector("#CartDrawer-Overlay")?.addEventListener(
      "click",
      this.close.bind(this),
    );
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    if (!cartLink) return;

    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    document.body.classList.remove("overflow-hidden");
  }

  shippingProductCart(id) {
    if (!id) return;

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: id,
        quantity: 1,
      }),
    })
      .then((response) => {
        this.updateCart();
        return response.json();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  addModalProduct(id) {
    if (!id) return;

    let updates = {
      [id]: 1,
    };

    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates }),
    })
      .then((response) => {
        this.updateCart();
        window.addOneModalHandler();
        document.body.classList.remove("modal--open");
        return response.json();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  shippingProduct(id) {
    if (!id) return;

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: id,
        quantity: 1,
      }),
    })
      .then((response) => {
        this.updateDrawer();
        return response.json();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id,
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open"),
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector,
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this),
      );
      this.open();
      this.initUpsellSlider();
    });
  }

  resetAtcButton() {
    $(".product-single__add-to-cart").find(".desk_btn_content").show();
    $(".product-single__add-to-cart").find(".desk_btn_loader").hide();
    $("[is-sticky-atc]").find(".desk_btn_content").show();
    $("[is-sticky-atc]").find(".desk_btn_loader").hide();
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "header-icons",
      },
    ];
  }

  updateCart() {
    fetch(window.location.href)
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        const newCart = doc.querySelector("#main-cart-items");
        const currenCart = document.querySelector("#main-cart-items");

        if (newCart && currenCart) {
          currenCart.innerHTML = newCart.innerHTML;
        }

        const cartCount = doc.querySelector(
          "#header-icons .js-drawer-open-button-right",
        );
        const currentCartCount = document.querySelector(
          "#header-icons .js-drawer-open-button-right",
        );

        if (cartCount && currentCartCount) {
          currentCartCount.innerHTML = cartCount.innerHTML;
        }

        this.initUpsellCartSlider();
      })
      .catch((error) => console.error("Error Cart Drawer:", error));
  }

  updateDrawer() {
    // Fetch only the cart-drawer section (~15KB) instead of the full page (~1–3MB)
    fetch("/?sections=cart-drawer")
      .then((response) => response.json())
      .then((sections) => {
        const html = sections["cart-drawer"];
        if (!html) return;

        const doc = new DOMParser().parseFromString(html, "text/html");
        const newDrawer = doc.querySelector("#CartDrawer .drawer__wrapper");
        const currentDrawer = document.querySelector(
          "#CartDrawer .drawer__wrapper",
        );

        if (newDrawer && currentDrawer) {
          if (currentDrawer.querySelector(".mobile-upsells.close")) {
            newDrawer.querySelector(".mobile-upsells")?.classList.add("close");
          }
          currentDrawer.innerHTML = newDrawer.innerHTML;
        }

        // Update cart count in background (non-blocking)
        fetch("/cart.js")
          .then((r) => r.json())
          .then((cart) => {
            const el = document.querySelector(
              "#header-icons .cart-button__count",
            );
            if (el) {
              el.querySelector(".cart-button__count-number").textContent = cart.item_count;
              el.style.display = cart.item_count > 0 ? "flex" : "none";
            }
          })
          .catch(() => {});

        document.querySelector("#cart-drawer").classList.add("active");
        document.body.classList.add("overflow-hidden");
        this.resetAtcButton();
        this.initUpsellSlider();
        document.dispatchEvent(new CustomEvent("cart:rendered"));

        // gtag("event", "Cart_Updated_Custom", {
        //   event_category: "User Actions",
        //   event_label: "Cart Updated (Custom)",
        //   value: 1,
        // });
      })
      .catch((error) => {
        console.error("Error Cart Drawer:", error);
        // gtag("event", "Cart_Error_Custom", {
        //   event_category: "User Actions",
        //   event_label: "Cart Error (Custom)",
        //   value: 1,
        // });
      });

    setTimeout(function () {
      window.setStockNote?.();
    }, 1000);
  }

  upsellInput(productInput) {
    let upsellCart =
      productInput.parentElement.parentElement.parentElement.parentElement;
    let upsellCartParent =
      productInput.parentElement.parentElement.parentElement.parentElement
        .parentElement;
    let label = productInput.querySelector("label");
    const radioId = label.getAttribute("data-radio-id");

    const radioButton = productInput.parentElement.parentElement.querySelector(
      `#${radioId}`,
    );
    radioButton.checked = true;
    let typeInput = [
      ...upsellCart.parentElement.parentElement.querySelectorAll(
        `.types .variant.color input[data-color="${radioButton.dataset.color}"]`,
      ),
    ].find((el) => el.name !== radioButton.name);
    typeInput ? (typeInput.checked = true) : "";
 
    upsellCart
      .querySelector(".upsell_cart__button")
      .setAttribute(
        "onclick",
        `window.cartDrawer?.shippingProduct(${radioButton.dataset.variant})`,
      );

    // console.log("changed id", radioButton.dataset.variant);

    const productLabel = upsellCart.querySelector(".product-item__label");
    if (productLabel) {
      productLabel.setAttribute("data-variant-id", radioButton.dataset.variant);
    }

    const upsellLabel = upsellCartParent.querySelector(
      ".upsells-cart-list__label",
    );
    // console.log(upsellLabel, upsellCartParent);
    if (upsellLabel) {
      upsellLabel.setAttribute("data-variant-id", radioButton.dataset.variant);
    }

    this.changeImage(upsellCart, radioButton.dataset.image);
    this.changePrice(
      upsellCart,
      radioButton.dataset.price,
      radioButton.dataset.compared,
      radioButton.dataset.badge,
      radioButton.dataset.variant,
    );
    this.updateCartItemVariantDiscount(
      upsellCart,
      radioButton.dataset.discount,
    );
  }

  upsellInputType(productInput) {
    setTimeout(function () {
      calculateMonitorArmStockOnClick();
    }, 10);
    let upsellCart =
      productInput.parentElement.parentElement.parentElement.parentElement;
    let checkedTypeInput = productInput.querySelector(".type-input");
    let colors = productInput.parentElement.querySelectorAll(".variant.color");
    colors.forEach((color) => {
      checkedTypeInput.dataset.name === color.dataset.name
        ? (color.style.display = "block")
        : (color.style.display = "none");
    });
    let checkedInput = upsellCart.parentElement.parentElement.querySelector(
      `.variant.color[data-name=${checkedTypeInput.dataset.name}] input[type="radio"]:checked`,
    );

    this.changeImage(upsellCart, checkedInput.dataset.image);
    this.changePrice(
      upsellCart,
      checkedInput.dataset.price,
      checkedInput.dataset.compared,
      checkedInput.dataset.badge,
      checkedInput.dataset.variant,
    );
    this.updateCartItemVariantDiscount(
      upsellCart,
      checkedInput.dataset.discount,
    );

    upsellCart
      .querySelector(".upsell_cart__button")
      .setAttribute(
        "onclick",
        `window.cartDrawer?.shippingProduct(${checkedInput.dataset.variant})`,
      );
  }

  // cart functions
  cartUpsellInput(productInput) {
    let upsellCart = productInput.parentElement.parentElement.parentElement;
    let label = productInput.querySelector("label");
    const radioId = label.getAttribute("data-radio-id");

    const radioButton = productInput.parentElement.parentElement.querySelector(
      `#${radioId}`,
    );
    radioButton.checked = true;
    let typeInput = [
      ...upsellCart.parentElement.parentElement.querySelectorAll(
        `.types .variant.color input[data-color="${radioButton.dataset.color}"]`,
      ),
    ].find((el) => el.name !== radioButton.name);
    typeInput ? (typeInput.checked = true) : "";

    const upsellLabel = upsellCart
      .closest("li")
      ?.querySelector(".upsells-cart-list__label");
    if (upsellLabel) {
      upsellLabel.setAttribute("data-variant-id", radioButton.dataset.variant);
    }

    this.changeImage(upsellCart, radioButton.dataset.image);
    this.changePrice(
      upsellCart,
      radioButton.dataset.price,
      radioButton.dataset.compared,
      radioButton.dataset.badge,
      radioButton.dataset.variant,
    );

    this.updateCartItemVariantDiscount(
      upsellCart,
      radioButton.dataset.discount,
    );

    // this.changePrice(upsellCart, radioButton.dataset.price, radioButton.dataset.compared, radioButton.dataset.badge);
    upsellCart
      .querySelector(".complete_cart__button")
      .setAttribute(
        "onclick",
        `window.cartDrawer?.shippingProductCart(${radioButton.dataset.variant})`,
      );

    upsellCart
      .querySelector(`.addOneVariantSelection.activeVariant`)
      ?.classList.remove("activeVariant");
    upsellCart
      .querySelector(
        `.addOneVariantSelection[data-id="${radioButton.dataset.variant}"]`,
      )
      .classList.add("activeVariant");
  }

  cartUpsellInputType(productInput) {
    setTimeout(function () {
      calculateMonitorArmStockOnClick();
    }, 10);
    let upsellCart = productInput.parentElement.parentElement.parentElement;
    let checkedTypeInput = productInput.querySelector(".type-input");
    let colors = productInput.parentElement.querySelectorAll(".variant.color");
    colors.forEach((color) => {
      checkedTypeInput.dataset.name === color.dataset.name
        ? (color.style.display = "block")
        : (color.style.display = "none");
    });
    let checkedInput = upsellCart.parentElement.parentElement.querySelector(
      `.variant.color[data-name=${checkedTypeInput.dataset.name}] input[type="radio"]:checked`,
    );

    upsellCart
      .querySelector(".complete_cart__button")
      .setAttribute(
        "onclick",
        `window.cartDrawer?.shippingProductCart(${checkedInput.dataset.variant})`,
      );
    this.changeImage(upsellCart, checkedInput.dataset.image);
    this.changePrice(
      upsellCart,
      checkedInput.dataset.price,
      checkedInput.dataset.compared,
      checkedInput.dataset.badge,
      checkedInput.dataset.variant,
    );
    this.updateCartItemVariantDiscount(
      upsellCart,
      checkedInput.dataset.discount,
    );
    // this.changePrice(upsellCart, checkedInput.dataset.price, checkedInput.dataset.compared, checkedInput.dataset.badge);

    upsellCart
      .querySelector(`.addOneVariantSelection.activeVariant`)
      ?.classList.remove("activeVariant");
    upsellCart
      .querySelector(
        `.addOneVariantSelection[data-id="${checkedInput.dataset.variant}"]`,
      )
      .classList.add("activeVariant");
  }

  changePrice(productCart, price, compared, badge, variantId) {
    const priceEl = productCart.querySelector(".price-block__price");
    const saleEl = productCart.querySelector(".price-block__sale");
    const badgeEl = productCart.querySelector(".price-block__badge");

    if (priceEl) {
      priceEl.innerHTML = price;
      if (variantId) {
        priceEl.setAttribute("data-variant-id", variantId);
      }
    }

    if (saleEl) {
      const hasCompare = compared && parseFloat(compared.replace(/[^0-9,.]/g, "").replace(",", ".")) > 0;
      saleEl.innerHTML = hasCompare ? compared : "";
      saleEl.style.display = hasCompare ? "" : "none";
      if (variantId) {
        saleEl.setAttribute("data-variant-id", variantId);
      }
    }

    if (badge && badgeEl) {
      badgeEl.innerHTML = badge;
      if (variantId) {
        badgeEl.setAttribute("data-variant-id", variantId);
      }
    }
  }

  updateCartItemVariantDiscount(productCart, discount) {
    let discountEl =
      productCart.querySelector(".product-item__label") ||
      productCart.closest("li")?.querySelector(".upsells-cart-list__label");
    if (discountEl) {
      discountEl.innerHTML = discount || "";
      discountEl.style.display = discount ? "" : "none";
    }
  }

  changeImage(productCart, imageSrc) {
    let productImage = productCart.querySelector("#upsell_cart_image");
    let currentSrc = productImage.src;
    let currentSrcset = productImage.srcset;
    let cdnIndex = currentSrc.indexOf("shop/");

    if (cdnIndex !== -1) {
      let updatedSrc = currentSrc.substring(0, cdnIndex + 5) + imageSrc;
      let updatedSrcset = currentSrcset.replace(
        /(shop\/)[^ ]+/g,
        `shop/${imageSrc}`,
      );

      productImage.srcset = updatedSrcset;
      productImage.src = updatedSrc;
    }
  }

  initUpsellCartSlider() {
    window.addOneModalHandler();
    new Swiper(".upsells-cart", {
      slidesPerView: "auto",
      spaceBetween: 16,
      loop: false,
      navigation: {
        nextEl: ".upsells-cart__button-next-mob",
        prevEl: ".upsells-cart__button-prev-mob",
      },
      breakpoints: {
        992: {
          spaceBetween: 20,
        },
      },
    });
  }

  initUpsellSlider() {
    new Swiper(".mobile-upsells-swiper", {
      slidesPerView: 1.11,
      spaceBetween: 40,
      loop: false,
      navigation: {
        nextEl: ".drawer__button-next-mob",
        prevEl: ".drawer__button-prev-mob",
      },
      pagination: {
        el: ".drawer .swiper-pagination",
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + ' bullet">' + "</span>";
        },
      },
    });
  }

  toggleUpsellSlider() {
    document.querySelector(".mobile-upsells").classList.toggle("close");
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

// console.log('==============');
window.cartDrawer = new CartDrawer();

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__wrapper",
      },
      {
        id: "header-icons",
        section: document.getElementById("header-icons").dataset.id,
        selector: ".js-drawer-open-button-right",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);

// Cart drawer quantity +/- handler
(function () {
  var updateTimer;
  $(document).on("click", "#cart-drawer .cart-quantity .quantity__button", function () {
    var $button = $(this);
    var $input = $button.closest("quantity-input").find(".quantity__input");
    var currentId = $button.closest(".cart-item").attr("data-id");
    if (!currentId || !$input.length) return;

    var $removeButton = $button.closest(".cart-item").find("cart-remove-button");
    clearTimeout(updateTimer);
    updateTimer = setTimeout(function () {
      var qty = parseInt($input.val(), 10);
      if (isNaN(qty) || qty < 0) return;

      $removeButton.addClass("loading");

      $.ajax({
        type: "POST",
        url: "/cart/update.js",
        data: JSON.stringify({ updates: { [currentId]: qty } }),
        dataType: "json",
        contentType: "application/json",
        success: function (cart) {
          var cartCountEl = document.querySelector("#header-icons .cart-button__count");
          if (cartCountEl) {
            cartCountEl.querySelector(".cart-button__count-number").textContent = cart.item_count;
            cartCountEl.style.display = cart.item_count > 0 ? "flex" : "none";
          }
          window.cartDrawer.updateDrawer();
        },
      });
    }, 500);
  });
})();

const cartDrawer = document.getElementById("cart-drawer");
const badge = $('[id^="trustbadge-container-"]');

if (cartDrawer) {
  const cartDrawerObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if ($(cartDrawer).hasClass("active")) {
        $('[id^="trustbadge-container-"]').hide();
      } else {
        $('[id^="trustbadge-container-"]').show();
      }
    });
  });

  cartDrawerObserver.observe(cartDrawer, {
    attributes: true,
    attributeFilter: ["class"],
  });
}

function calculateMonitorArmStockOnClick() {
  // console.log("calculating");
  var alreadyClicked = false;
  $(".upsell_cart_item_type_mob_input__js").each(function () {
    // console.log('here');
    if ($(this).closest(".upsell_item_li").attr("style") != "display: none;") {
      if ($(this).closest(".upsell_item_li").hasClass("variantNotInStock")) {
        // console.log( 'variantNotInStock');
      } else {
        if (alreadyClicked == false) {
          $(this).closest(".upsell_item_li").trigger("click");
          alreadyClicked = true;
        }
      }
    }
  });

  alreadyClicked = false;
  $(".upsell_cart_item_type_2_input__js").each(function () {
    if ($(this).closest(".upsell_item_li").attr("style") != "display: none;") {
      if ($(this).closest(".upsell_item_li").hasClass("variantNotInStock")) {
      } else {
        if (alreadyClicked == false) {
          $(this).closest(".upsell_item_li").trigger("click");
          alreadyClicked = true;
        }
      }
    }
  });

  alreadyClicked = false;
  $(".upsell_cart_item_type_cart_input__js").each(function () {
    if ($(this).closest(".upsell_item_li").attr("style") != "display: none;") {
      if ($(this).closest(".upsell_item_li").hasClass("variantNotInStock")) {
      } else {
        if (alreadyClicked == false) {
          $(this).closest(".upsell_item_li").trigger("click");
          alreadyClicked = true;
        }
      }
    }
  });
}
